export const adaptiveLevelKeys = {
  all: ["adaptive-levels"] as const,
  classrooms: () => [...adaptiveLevelKeys.all, "classroom"] as const,
  classroom: (classroomId: string, page: number, pageSize: number) =>
    [...adaptiveLevelKeys.classrooms(), classroomId, page, pageSize] as const,
  classroomPrefix: (classroomId: string) =>
    [...adaptiveLevelKeys.classrooms(), classroomId] as const,
  students: () => [...adaptiveLevelKeys.all, "student"] as const,
  student: (studentId: string, page: number, pageSize: number) =>
    [...adaptiveLevelKeys.students(), studentId, page, pageSize] as const,
  studentPrefix: (studentId: string) => [...adaptiveLevelKeys.students(), studentId] as const,
}
